import Enum from '../../../enum/Enum';

export const ACTIVE_STATUS = Enum({
  InActive: 'InActive',
  Active: 'Active',
});

export const APPROVE_STATUS = Enum({
  Pending: 'Pending',
  Approved: 'Approved',
  // Reject: 'Reject'
});

export const REGISTER_LEVEL2 = Enum({
  Level1: false,
  Level2: true,
});

export const SEARCH_PARAM = {
  registerLevel2: [],
  activeStatuses: [],
  approveStatuses: [],
};

export const FORM_VALUE = {
  fullName: '',
  email: '',
  dateOfBirth: null,
  gender: '',
  address: '',
  mobile: '',
  identityType: 'NRIC',
  ignoredUnitNumber: false,
};

export const LIST_REQUIRED = [
  'fullName',
  'email',
  'notificationEmail',
  'dateOfBirth',
  'gender',
  'mobile',
  'identityNumber',
];

export const LIST_LV1_REQUIRED = [
  'fullName',
  'email',
  'notificationEmail',
  'dateOfBirth',
  'gender',
  'mobile',
];

export const LIST_REQUIRED_CHILDREN = [
  'notificationEmail',
  'fullName',
  'dateOfBirth',
  'gender',
  'identityNumber',
];

export const NATIONALITY = [
  'Afghan',
  'Albanian',
  'Algerian',
  'American',
  'Andorran',
  'Angolan',
  'Antiguan',
  'Argentinean',
  'Armenian',
  'Australian',
  'Austrian',
  'Azerbaijani',
  'Bahamian',
  'Bahraini',
  'Bangladeshi',
  'Barbadian',
  'Barbudans',
  'Batswana',
  'Belarusian',
  'Belgian',
  'Belizean',
  'Beninese',
  'Bermudian',
  'Bhutanese',
  'Bolivian',
  'Bosnian',
  'Brazilian',
  'British',
  'Bruneian',
  'Bulgarian',
  'Burkinabe',
  'Burundian',
  'Cambodian',
  'Cameroonian',
  'Canadian',
  'Cape Verdean',
  'Central African',
  'Chadian',
  'Chilean',
  'Chinese',
  'Colombian',
  'Comoran',
  'Congolese',
  'Costa Rican',
  'Croatian',
  'Cuban',
  'Cypriot',
  'Czech',
  'Danish',
  'Djibouti',
  'Dominican',
  'Dutch',
  'East Timorese',
  'Ecuadorean',
  'Egyptian',
  'Emirian',
  'Equatorial Guinean',
  'Eritrean',
  'Estonian',
  'Ethiopian',
  'Fijian',
  'Filipino',
  'Finnish',
  'French',
  'Gabonese',
  'Gambian',
  'Georgian',
  'German',
  'Ghanaian',
  'Gibraltarian',
  'Greek',
  'Grenadian',
  'Guatemalan',
  'Guinea-Bissauan',
  'Guinean',
  'Guyanese',
  'Haitian',
  'Herzegovinian',
  'Honduran',
  'Hongkonger',
  'Hungarian',
  'I-Kiribati',
  'Icelander',
  'Indian',
  'Indonesian',
  'Iranian',
  'Iraqi',
  'Irish',
  'Israeli',
  'Italian',
  'Ivorian',
  'Jamaican',
  'Japanese',
  'Jordanian',
  'Kazakhstani',
  'Kenyan',
  'Kittian And Nevisian',
  'Kuwaiti',
  'Kyrgyz',
  'Laotian',
  'Latvian',
  'Lebanese',
  'Liberian',
  'Libyan',
  'Liechtensteiner',
  'Lithuanian',
  'Luxembourger',
  'Macedonian',
  'Malagasy',
  'Malawian',
  'Malaysian',
  'Maldivian',
  'Malian',
  'Maltese',
  'Marshallese',
  'Mauritanian',
  'Mauritian',
  'Mexican',
  'Micronesian',
  'Moldovan',
  'Monacan',
  'Mongolian',
  'Moroccan',
  'Mosotho',
  'Motswana',
  'Mozambican',
  'Myanmar',
  'Namibian',
  'Nauruan',
  'Nepalese',
  'New Zealander',
  'Nicaraguan',
  'Nigerian',
  'Nigerien',
  'Ni-Vanuatu',
  'North Korean',
  'Northern Irish',
  'Norwegian',
  'Omani',
  'Pakistani',
  'Palauan',
  'Panamanian',
  'Papua New Guinean',
  'Paraguayan',
  'Peruvian',
  'Polish',
  'Portuguese',
  'Qatari',
  'Romanian',
  'Russian',
  'Rwandan',
  'Saint Lucian',
  'Salvadoran',
  'Samoan',
  'San Marinese',
  'Sao Tomean',
  'Saudi',
  'Scottish',
  'Senegalese',
  'Serbian',
  'Seychellois',
  'Sierra Leonean',
  'Singaporean',
  'Slovakian',
  'Slovenian',
  'Solomon Islander',
  'Somali',
  'South African',
  'South Korean',
  'Spanish',
  'Sri Lankan',
  'Sudanese',
  'Surinamer',
  'Swazi',
  'Swedish',
  'Swiss',
  'Syrian',
  'Taiwanese',
  'Tajik',
  'Tanzanian',
  'Thai',
  'Togolese',
  'Tongan',
  'Trinidadian/Tobagonian',
  'Tunisian',
  'Turkish',
  'Turkmen',
  'Tuvaluan',
  'Ugandan',
  'Ukrainian',
  'Uruguayan',
  'Uzbekistani',
  'Venezuelan',
  'Vietnamese',
  'Welsh',
  'Yemenite',
  'Yugoslavian',
  'Zambian',
  'Zimbabwean',
  'Others',
];

export const renderCorporateColumn = () => {
  const tableComlumn = [
    {
      label: 'Corporate Name',
      stateValue: 'corporatePlanType',
    },
    {
      label: 'Corporate Front Photo',
      stateValue: 'frontPhoto',
    },
    {
      label: 'Corporate Back Photo',
      stateValue: 'backPhoto',
    },
    {
      label: '',
      stateValue: 'action',
    },
  ];
  return tableComlumn;
};

export const LIST_ETHNIC_GROUP = ['Chinese', 'Malay', 'Indian', 'Others'];
